import React, { useRef, useState } from 'react'
import { Link, Popover } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Backdrop } from '../Backdrop'

const CenterContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
})

const DropdownAnchor = styled('span')(({ anchorPosition }) => ({
    position: 'relative',
    top: '5.4rem',
    ...anchorPosition,
}))

const PopupMenu = ({
    displayIcon,
    style,
    onOpen,
    onClose,
    handleItemSelection,
    menuHeight,
    children,
    anchorPosition,
    showCone = true,
    ...rest
}) => {
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
        onClose && onClose()
    }

    return (
        <>
            <CenterContainer sx={{ position: 'relative', ...style }}>
                <Link
                    underline="none"
                    component="button"
                    onClick={() => {
                        onOpen && onOpen()
                        setOpen((prev) => !prev)
                    }}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {displayIcon}
                </Link>
                <DropdownAnchor
                    ref={anchorRef}
                    anchorPosition={anchorPosition}
                />
            </CenterContainer>

            <Popover
                open={open}
                anchorEl={anchorRef.current}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                disableScrollLock={true}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                BackdropComponent={Backdrop}
            >
                {children}
            </Popover>
        </>
    )
}

export default PopupMenu
